import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  ordersTab: {
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: "24px 32px 24px 32px",
  },
  uiTab: {
    minHeight: "calc(100vh - 310px) !important",
    height: "100% !important",
  },
  headerBreadcrumbs: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  headerBreadcrumbsTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: "bold",
    color: "#38cfc4",
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
  },
  Wrapper: {
    // padding: "24px 24px 0 24px",
  },
}));

export default styles;
